import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'deviations',
    templateUrl: 'deviation.component.html',
  standalone: false
})
export class DeviationFormComponent implements OnInit {
    
    constructor(){
  }   ngOnInit(): void {
    document.querySelector("body").classList.remove("opened");
    }
}
